import React from 'react';
import { ErrorMessage, Field } from 'formik';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Cleave from 'cleave.js/react';
import styled, { css } from 'styled-components';
import { accent, white, gray, primary, tertiary } from '~/components/mixins/color';
import 'cleave.js/dist/addons/cleave-phone.br';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Group = styled.div`
  display: grid;
  position: relative;
  margin: ${(props) => props.noMargin ? '0' : '0 0 10px'};
  width: 100%;

  & > svg {
    position: absolute;
    right: 15px;
    align-self: center;
    color: #555;
  }

  &:focus-within > input {
    border-color: ${accent.hex()};
  }

  &:focus-within > svg {
    color: ${accent.hex()};
  }

  ${(props) => props.required && css`
    label {
      font-weight: 800;
    }
  `};

  input {
    background: ${primary.hex()};
    border: 2px solid ${tertiary.hex()};
    border-radius: 4px;
    padding: 20px 0 8px 9px;
    color: ${white.hex()};
    transition: border-color 0.2s ease-in 0s;
    height: 46px;

    &:disabled {
      background-color: ${primary.lighten(0.8).hex()};
      color: ${gray.hex()};
    }

    &:focus + label,
    &:not([value=""]) + label {
      font-size: 70%;
      transform: translate3d(0, -100%, 0);
      opacity: 1;
      top: 20px;
    }
    & + label {
      position: absolute;
      top: 15px;
      padding-left: 10px;
      transition: all 200ms;
      color: ${white.hex()};
    }
  }
`;

const InputMask = ({ name, label = '', noMargin, required, hideErrorLabel, mask = {}, hasError, icon: Icon, className, ...rest }) => (
  <Container>
    <Field type="text" id={name} name={name}>
      {({ field }) => (
        <Group required={required} noMargin={noMargin}>
          <Cleave
            {...field}
            {...rest}
            placeholder={`${label}${required ? ' (*)' : ''}`}
            options={mask}
            className={!!hasError ? 'error' : ''}
            value={rest.value || field.value || ''}
            style={field.value ? {} : { padding: "15px 8px" }}
            onChange={(event) => {
              const tempEvent = event;
              tempEvent.target.value = event.target.rawValue;
              field.onChange(tempEvent);
              if (rest.onChange) {
                rest.onChange(tempEvent);
              }
            }}
            />
          {_.trim(field.value) && <label htmlFor={name}>{label}{required ? ' (*)' : ''}</label>}
          {Icon && <Icon size={20} />}
        </Group>
      )}
    </Field>
    {!hideErrorLabel && <ErrorMessage name={name} className='error' component='div' /> }
  </Container>
);

InputMask.propTypes = {
  name: PropTypes.string.isRequired,
  mask: PropTypes.object.isRequired,
  label: PropTypes.string,
  hasError: PropTypes.bool,
};

InputMask.defaultProps = {
  hasError: false,
};

export default InputMask;

// EXEMPLO DE USO
// <InputMask
//     mask={MASK_PHONE}
//     name="phone"
//     label="Telefone"
//     hasError={errors.phone && touched.phone} />
